

















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetArrowClose extends Vue {
  @Prop({ default: '14' }) readonly width?: string;
  @Prop({ default: '8' }) readonly height?: string;
  @Prop({ default: 'currentColor' }) readonly color?: string;
}
